export type AbVariant = 'trial' | 'full'

export interface TrialCheckoutResponse {
  success: boolean
  paymentUrl?: string
  error?: string
}

export interface LastPaymentResponse {
  success: boolean
  amount?: number
  paidAt?: string
  paidUntil?: string
  nextChargeAmount?: number
  abVariant?: AbVariant
  isRecurrentActive?: boolean
  error?: string
}

export async function getLastPayment(channelUUID: string): Promise<LastPaymentResponse> {
  const res = await fetch(
    `/api/max/payment/last?channelUUID=${encodeURIComponent(channelUUID)}`,
    { credentials: 'include' },
  )
  if (res.status === 403 || res.status === 404) {
    const body = await res.json().catch(() => ({}))
    return { success: false, error: body.error || `HTTP ${res.status}` }
  }
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`)
  }
  return res.json()
}

export async function startTrialCheckout(
  channelUUID: string,
  email: string,
  abVariant: AbVariant = 'full',
): Promise<TrialCheckoutResponse> {
  const res = await fetch('/api/max/payment/trial-checkout', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      entityId: channelUUID,
      entityType: 'channel',
      email,
      abVariant,
      clientType: 'desktop',
    }),
  })
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(`HTTP ${res.status}: ${text.slice(0, 200)}`)
  }
  return res.json()
}
